var PriceMixin = {
  data: function () {
    return {
      baseRingPrice: 0,
      fromDiamondPrice: 0,
      diamondPrice: 0,
      additionalPrice: 0,
    };
  },
  mounted: function () {
    this.initEvents();
  },
  computed: {
    totalPrice: function () {
      var totalPrice =
        this.baseRingPrice +
        (this.diamondPrice ? this.diamondPrice : this.fromDiamondPrice) +
        this.additionalPrice;
      this.broadcast("rb-total-price-update", { totalPrice });
      return totalPrice;
    },
  },
  methods: {
    initEvents: function () {
      this.subscribe("rb-update-price", this.onUpdatePrice);
    },
    onUpdatePrice: function (data) {
      this.updatePrice(data);
    },
    updatePrice: function (data) {
      // console.log("data price", data);
      this.baseRingPrice = data.baseRingPrice;
      this.diamondPrice = 0;
      this.fromDiamondPrice = data.fromDiamondPrice;
      this.additionalPrice = data.selectedOptions
        .filter((selectedOption) => selectedOption.choice.additionalPrice)
        .reduce(
          (total, option) => total + option.choice.additionalPrice / 100,
          0
        );
      var diamondPriceData = data.selectedOptions.find(
        (selectedOption) => selectedOption.step.id === "diamond"
      );
      if (diamondPriceData) {
        this.diamondPrice = parseInt(diamondPriceData.choice.retail_price);
      }
      // Get Additional Price (search for options with choices that have additional price)
    },
  },
};
export default PriceMixin;
